import React from 'react';

const NotificationFormModal = ({
  show,
  title,
  onClose,
  onSave,
  children,
  bodyTop = null,
  footerContent = null,
  saveDisabled = false,
  saveLabel = 'Save',
  closeLabel = 'Close',
}) => {
  if (!show) return null;

  return (
    <div className="modal modal-backdrop show d-block" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            {bodyTop}
            <div className="row g-3">{children}</div>
          </div>
          <div className="modal-footer">
            {footerContent}
            <button className="btn btn-primary" onClick={onSave} disabled={saveDisabled}>
              {saveLabel}
            </button>
            <button className="btn btn-secondary" onClick={onClose}>
              {closeLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationFormModal;
